import { AfterViewInit, Component, ElementRef, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';

import { environmentOm } from '../../../../environment-om';
import { ReportsApi } from '../../../api/reports-api';
import { ILegislativeDistrict, ReportHelper } from '../../report-helper';

@Component({
    selector: 'om-hop-detail-report',
    templateUrl: './hopDetailReport.html',
    styleUrls: ['../../reports.css', './hopDetailReport.css']
})

export class HopDetailReportComponent implements AfterViewInit {
    public defaultExtent;
    private objectId: any;
    private layerId: any;
    reportData;
    public geomapConfig = {
        basemaps: ['streets'],
        name: 'map'
    };
    private readonly legData: {
        congress: ILegislativeDistrict;
        house: ILegislativeDistrict;
        senate: ILegislativeDistrict;
    } = <any>{};
    error = false;
    errorMessage = this.reportHelper.reportErrorMessages.noReportData;
    isGenerating = false;
    isLoadingMap = false;
    @ViewChild('mcMap', { static: false }) mapRef: ElementRef<any>;
    defaultBasemap = {
        tileUrl: environmentOm.basemapURL + '/rest/services/basemaps/penndotbasemap/MapServer/tile',
        thumbnailTile: '/7/48/36',
        tileTemplate: '/{level}/{row}/{col}',
        title: 'PennDOT'
    };

    constructor(private readonly reportsApi: ReportsApi,
                private readonly reportHelper: ReportHelper,
                private readonly route: ActivatedRoute,
                titleService: Title) {
        titleService.setTitle(titleService.getTitle() + ' : Hop Detail Report');
    }

    async ngAfterViewInit() {
        this.isGenerating = true;
        this.route.paramMap.subscribe(x => {
            this.objectId = JSON.parse(window.localStorage.getItem(x.get('id'))).hopId;
            this.layerId = JSON.parse(window.localStorage.getItem(x.get('id'))).layerId;
            this.loadMap();
            this.loadReport();
            this.isGenerating = false;
        });
    }

    private async loadMap() {
        try {
            this.isLoadingMap = true;
            await this.mapRef.nativeElement.ready;
            await this.mapRef.nativeElement.setBasemapsFromConfig(this.defaultBasemap);
            const layerSettings = { id: parseInt(this.layerId, 10), query: { field: 'objectId', operator: '=', value: this.objectId }, zoomToLayer: true };
            this.mapRef.nativeElement.LayerService.addMapcoreLayersToMap([layerSettings]);

        } finally {
            this.isLoadingMap = false;
        }
    }

    private async loadReport() {
        this.isGenerating = true;
        try {
            this.reportData = await this.reportsApi.getHopDetailReportData(parseInt(this.objectId, 10));
            if (this.reportData.congresS_DISTRICT_NO) {
                this.legData.congress = await this.reportHelper.getCongressionalDistrictByName(parseInt(this.reportData.congresS_DISTRICT_NO, 10));
            } else { this.legData.congress = null; }
            if (this.reportData.senatE_DISTRICT_NO) {
                this.legData.senate = await this.reportHelper.getSenateDistrictByName(parseInt(this.reportData.senatE_DISTRICT_NO, 10));
            } else { this.legData.senate = null; }
            if (this.reportData.housE_DISTRICT_NO) {
                this.legData.house = await this.reportHelper.getHouseDistrictByName(parseInt(this.reportData.housE_DISTRICT_NO, 10));
            } else { this.legData.house = null; }
            this.isGenerating = false;
        } catch (error) {
            this.isGenerating = false;
            this.error = true;
        }
    }
}
